import {Avatar} from 'antd'
import {course_getStudentById_Api} from 'apis'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {BsInfoCircleFill} from 'react-icons/bs'
import {FaUserTie} from 'react-icons/fa6'
import {Link} from 'react-router-dom'
import {MdContactPhone} from 'react-icons/md'
import {PiCertificate} from 'react-icons/pi'
import {getResponseItem, renderIf, renderIfElse} from '../../../../Shared'
import {IdentityVerificationSection} from './StudentIdentitySection'
import {IdentifierTypes} from '../../../appFieldTypes'
import getAvatar from "../../../../../helpers/getAvatar";
import getTitle from "../../../../../helpers/getTitle";
import ImageLoader from "../../../../../components/ImageLoader";
import {NoImage, Photo} from "../../../../../conts/imageBase64";
import getLabelOfGender from "../../../../../helpers/getLabelOfGender";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {ItemInformation} from 'components/common/ItemInformation'
import getLinkToDetail from "../../../../../helpers/getLinkToDetail";
import {bindQueryParam} from "../../../functions/routerHelper";
import useAsync from "../../../../../modules/asyncCache/useAsync";
import {getId} from "../../../../../apis/model/base";
import getAliasName from "../../../../../helpers/getAliasName";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {convertStringToDate} from "../../../../../helpers/dateUtils";
import {formatDate} from "../../../../../helpers/datetimeHelpers";


export const StudentInformationFull = ({student, medal_awards = []}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const apiInfo = course_getStudentById_Api

    const id = getId(student) || student

    const {response, isLoading = false, handleAsyncAction: refresh} = useAsync({
        apiInfo,
        query: bindQueryParam({id}),
    })

    const item = getResponseItem(response)

    const {
        avatar,
        notes,
        edit,
        user,
        student_idcode,
        identifier_code,
        identifier_type,
        place_of_birth,
        patron_saint,
        patron_saint_name,
        fullname,
        contact_address,
        gender, date_of_birth,
        contact_phone,
        contact_email,
        religious_order,
        religious_order_name,
        parish,
        parish_name,
        diocese,
        diocese_name,
    } = item ?? {}

    const typeIdentify = _.find(IdentifierTypes, {value: identifier_type})?.label

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2 pb-1.5 border-b border-color-50">
                    <BsInfoCircleFill size={12} className="text-color-400 flex-shrink-0"/>
                    <span className="text-xs font-semibold uppercase tracking-widest text-color-400">
            {t('student information')}
          </span>
                </div>
                <div className="flex gap-3">
                    <ImageLoader
                        style={{width: isSm ? 100 : 130, height: isSm ? 100 : 130}}
                        src={avatar || NoImage}
                        fallback={NoImage}
                        className="background-200 rounded-xl object-cover mt-1"
                    />
                    <div className="flex flex-col flex-1 min-w-0 gap-1">
                        <ItemInformation
                            primary={true}
                            showIcon={true}
                            label={!isSm && "full name"}
                            value={`${getAliasName(item, 'patron_saint') || ''} ${fullname}`}
                            className="text-sm italic tracking-wider"
                        />
                        {renderIf(
                            edit === true && identifier_type,
                            <ItemInformation showIcon={true} className="italic tracking-wider" label={t(typeIdentify)}
                                             value={identifier_code}/>
                        )}
                        {renderIf(
                            gender !== 0,
                            <ItemInformation showIcon={true} label={!isSm && "gender"}
                                             value={t(getLabelOfGender(gender))} className="italic tracking-wider"/>
                        )}
                        {renderIf(
                            _.some([date_of_birth, place_of_birth]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst={!isSm && "date of birth"}
                                valueFirst={date_of_birth ? convertStringToDate(date_of_birth).format('DD/MM/YYYY') : t('not update')}
                                labelSecond={place_of_birth ? ' - ' : ''}
                                valueSecond={place_of_birth}
                                className="italic tracking-wider"
                            />
                        )}
                        {renderIf(
                            notes,
                            <ItemInformation showIcon={true} className="italic tracking-wider" label="note"
                                             value={notes}/>
                        )}
                        {renderIf(
                            user,
                            <div className="flex items-center gap-3">
                                <Avatar
                                    size={30}
                                    src={getAvatar(user)}
                                    icon={<FaUserTie size={16} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                                />
                                <div className="flex flex-col flex-1">
                  <span className="text-blue-500 italic tracking-wider">
                    {`${t('link account')} : `}
                  </span>
                                    {renderIfElse(
                                        edit === true,
                                        <Link
                                            target="_blank" to={getLinkToDetail(user)}
                                            className="font-medium text-primary-700 no-underline leading-snug">
                                            {getAliasName(user, 'patron_saint')}
                                            {` ${getTitle(user)}`}
                                        </Link>,
                                        <span className="font-medium text-primary-700 leading-snug">
                      {getAliasName(user, 'patron_saint')}
                                            {getTitle(user)}
                    </span>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2 pb-1.5 border-b border-color-50">
                    <MdContactPhone size={13} className="text-color-400 flex-shrink-0"/>
                    <span className="text-xs font-semibold uppercase tracking-widest text-color-400">
            {t('contact information')}
          </span>
                </div>
                <div className="background-50 rounded-xl border border-color-50 p-3 flex flex-col gap-2">
                    {renderIf(
                        _.some([parish_name, diocese_name]),
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="belong to parish"
                            valueFirst={parish_name}
                            labelSecond={diocese_name && " - " || ''}
                            valueSecond={diocese?.fullname}
                            className="italic tracking-wider"
                        />
                    )}
                    {renderIf(
                        religious_order_name,
                        <ItemInformation
                            showIcon={true}
                            label="belong to religious order"
                            value={
                                <Link to={getLinkToDetail(religious_order)} className="no-underline">
                                    {religious_order_name}
                                </Link>
                            }
                            className="italic tracking-wider"
                        />
                    )}
                    <ItemInformation showIcon={true} label="phone" value={contact_phone}
                                     className="italic tracking-wider"/>
                    <ItemInformation showIcon={true} label="email" value={contact_email}
                                     className="italic tracking-wider"/>
                    <ItemInformation showIcon={true} label="address" value={contact_address}
                                     className="italic tracking-wider"/>
                </div>
            </div>

            {/* Identity Verification Section */}
            {item && (
                <IdentityVerificationSection
                    item={item}
                    onRefresh={refresh}
                />
            )}

            {renderIf(
                medal_awards?.length > 0,
                <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-2 pb-1.5 border-b border-color-50">
                        <PiCertificate size={13} className="text-color-400 flex-shrink-0"/>
                        <span className="text-xs font-semibold uppercase tracking-widest text-color-400">
              {t('certification awarded')}
            </span>
                    </div>
                    <div className="ml-2 flex flex-col gap-1">
                        {medal_awards.map((e, i) => (
                            <div key={i} className="w-full flex items-center gap-x-3 border border-color-50 rounded-md">
                                {renderIfElse(
                                    e?.medal?.avatar,
                                    <ImageLoader
                                        style={{width: 80, height: 55}}
                                        src={e?.medal?.avatar}
                                        fallback={Photo}
                                        className="rounded-l-md object-cover"
                                    />,
                                    <div style={{width: 80, height: 55}}
                                         className="flex flex-center background-100 rounded-l-md">
                                        <PiCertificate size={40} style={{color: '#dddddd'}}/>
                                    </div>
                                )}
                                <div className="flex flex-col flex-1 min-w-0 gap-1">
                  <span className="font-bold text-sm text-primary leading-tight">
                    {getTitle(e.medal)}
                  </span>
                                    <span className="flex items-center gap-1 text-xs italic leading-tight">
                    <span className="text-color-500">{`${t('date of award')} : `}</span>
                    <span
                        className="font-bold text-color-100">{formatDate(e?.medal?.eff_date, 'DD/MM/YYYY')}</span>
                  </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}
